<div class="hmf-global-chips-container"
[ngClass]="visibleFilter ? 'visible-filter': ''"
(click)="toggleFilter()">
    <div
        class="global-chip hmf-subheader-bold-m hmf-body-m hmf-px-xs hmf-py-xxxs"
        tabindex="0"
        [ngClass]="isSelected ? 'global-chips--active' :''">
        {{label}}
        <!-- dispaly selected delivery zipcode or store location in the filter chip -->
        <span *ngIf="shouldShowLocation" class="hmf-px-xxxs">{{label === 'Pickup'  ? 'at' : 'to'}}</span>
        <span *ngIf="shouldShowLocation">{{(label === 'Pickup' ? selectedStoreName : selectUserZipCode) | titlecase }}</span>
        <span *ngIf="showCancelSign" class="hmf-pl-xs">
            <homefield-icon class="hmf-global-chip-svg" width="20px" height="20px" name="sign-cancel"></homefield-icon>
        </span>
    </div>
</div>
